import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import React from 'react';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';


function SwitchLanguage({ t, buttonColor }) {
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }

    return (
        <ButtonGroup 
            variant="text"
            sx={buttonColor ? {
                '& .MuiButtonGroup-grouped:not(:last-of-type)': {
                    borderColor: buttonColor,
                }
            } : {}}
        >
            <Button 
                onClick={() => changeLanguage("en")}
                sx={buttonColor ? { color: buttonColor, '&:hover': { bgcolor: `${buttonColor}15` } } : {}}
            >
                En
            </Button>
            <Button 
                onClick={() => changeLanguage("zh")}
                sx={buttonColor ? { color: buttonColor, '&:hover': { bgcolor: `${buttonColor}15` } } : {}}
            >
                中
            </Button>
        </ButtonGroup>
    )
}
export default withTranslation()(SwitchLanguage);